export const useAccountEligibility = () => {
  const { user } = useAuth();

  const isAccountComplete = computed(
    () => user.value?.accountDetailsChecks?.isAccountDetailsCompleted ?? false,
  );

  return { isAccountComplete };
};
